import React from 'react';
import { Link } from 'react-router';

import { Flex } from 'src/common/components/flex/flex';
import { Text } from 'src/common/components/text/text';

import './black-friday-banner.css';

export const BlackFridayBanner = () => {
  return (
    <Link
      to="/pricing?src_internal=black-friday-2023-banner"
      className="black-friday-banner__link"
    >
      <Flex className="black-friday-banner">
        <Flex className="black-friday-banner__ticker">
          <Text>Limited offer 25% off. Get our lowest price on Pro ever!</Text>
        </Flex>
      </Flex>
    </Link>
  );
};
